const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
 * @function evalute - evaluate comparatorBehavior
 *
 * This function is a generalised version of the template behavior
 * `stringCompareBehavior`, as used by `effectiveCriteriaBehavior`,
 * but considerably more efficient.
 */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const left = await evaluateSource(source.leftValue, content, parentContentPath, transientContext, nativeFunctions);
  const right = await evaluateSource(source.rightValue, content, parentContentPath, transientContext, nativeFunctions);
  if (left === undefined || right === undefined) {
    return undefined;
  }

  // when comparing items of the same type,
  // use JS's built-in comparators
  if (typeof left === typeof right) {
    if (left < right) {
      return -1;
    }
    if (left > right) {
      return 1;
    }
    return 0;
  }

  // define numbers to precede strings (i.e. when a string
  // and a number are compared, the number will come first).
  if (typeof left === 'number' && typeof right === 'string') {
    return -1;
  }
  if (typeof left === 'string' && typeof right === 'number') {
    return 1;
  }

  // other orderings are not defined
  return undefined;
};
module.exports = {
  evaluate
};